import { Document, Page } from "@react-pdf/renderer";
import { ContainerRow } from "./ContainerRow";

export const ContainersListPdf = ({ data }) => {
  return (
    <Document
      creator="Akanthas"
      producer="Akanthas"
      style={{ fontFamily: "Open Sans" }}
    >
      <Page size="A4" style={{ backgroundColor: "#F5F5F5" }}>
        {data.map((item) => {
          return <ContainerRow data={item} />;
        })}
      </Page>
    </Document>
  );
};
